import { render, staticRenderFns } from "./RecipeList.vue?vue&type=template&id=d73886f2"
import script from "./RecipeList.vue?vue&type=script&lang=js"
export * from "./RecipeList.vue?vue&type=script&lang=js"
import style0 from "./RecipeList.vue?vue&type=style&index=0&id=d73886f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports